export const UNREPLIED_THRESHOLD_MS = 10 * 60 * 1000;

// A última mensagem do cliente que pede resposta (lastClientActionAt): a
// resposta curta ("Ok", "👍") não deixa o ticket "sem resposta". Sem o campo
// (backend antigo), vale a última mensagem dele, como antes.
const lastCustomerAt = (ticket) =>
  ticket.lastClientActionAt !== undefined ? ticket.lastClientActionAt : ticket.lastClientMessageAt;

export const isTicketUnreplied = (ticket, now = Date.now()) => {
  if (!ticket || ticket.status !== "open") return false;
  const customerAt = lastCustomerAt(ticket);
  if (!customerAt) return false;
  const lastClient = new Date(customerAt).getTime();
  if (Number.isNaN(lastClient)) return false;
  if (now - lastClient <= UNREPLIED_THRESHOLD_MS) return false;
  const lastAgent = ticket.lastAgentMessageAt
    ? new Date(ticket.lastAgentMessageAt).getTime()
    : 0;
  return lastAgent < lastClient;
};
